import * as ActionType from "./giftTransaction.type";

const initialState = {
  giftTransaction: [],
  stats: {},
};

export const giftTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_GIFT_TRANSACTION:
      return {
        ...state,
        giftTransaction: action.payload,
      };

    case ActionType.GET_TRANSACTION_STATS:
      return {
        ...state,
        stats: action.payload,
      };

    default:
      return state;
  }
};
